// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_json from "rescript/lib/es6/js_json.js";
import * as Auth0Js from "auth0-js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Utils_Json$LiveRoom from "../Utils/Utils_Json.bs.js";

function auth0configToJs(param) {
  return {
          domain: param.domain,
          clientID: param.clientID,
          redirectUri: param.redirectUri,
          responseType: param.responseType,
          responseMode: param.responseMode,
          scope: param.scope,
          audience: param.audience
        };
}

function auth0configFromJs(param) {
  return {
          domain: param.domain,
          clientID: param.clientID,
          redirectUri: param.redirectUri,
          responseType: param.responseType,
          responseMode: param.responseMode,
          scope: param.scope,
          audience: param.audience
        };
}

function loginUrlBuilderOptionsToJs(param) {
  return {
          clientID: param.clientID,
          redirectUri: param.redirectUri,
          responseType: param.responseType,
          responseMode: param.responseMode,
          state: param.state,
          nonce: param.nonce,
          connection: param.connection,
          scope: param.scope,
          audience: param.audience,
          loginHint: param.loginHint
        };
}

function loginUrlBuilderOptionsFromJs(param) {
  return {
          clientID: param.clientID,
          redirectUri: param.redirectUri,
          responseType: param.responseType,
          responseMode: param.responseMode,
          state: param.state,
          nonce: param.nonce,
          connection: param.connection,
          scope: param.scope,
          audience: param.audience,
          loginHint: param.loginHint
        };
}

function logoutUrlBuilderOptionsToJs(param) {
  return {
          clientID: param.clientID,
          returnTo: param.returnTo
        };
}

function logoutUrlBuilderOptionsFromJs(param) {
  return {
          clientID: param.clientID,
          returnTo: param.returnTo
        };
}

function checkSessionOptionsToJs(param) {
  return {
          timeout: param.timeout
        };
}

function checkSessionOptionsFromJs(param) {
  return {
          timeout: param.timeout
        };
}

function logoutOptionsToJs(param) {
  return {
          returnTo: param.returnTo
        };
}

function logoutOptionsFromJs(param) {
  return {
          returnTo: param.returnTo
        };
}

var AuthZeroJs = {
  logoutOptionsToJs: logoutOptionsToJs,
  logoutOptionsFromJs: logoutOptionsFromJs
};

function parseResponse(data) {
  var json = JSON.parse(data);
  return {
          accessToken: Utils_Json$LiveRoom.Decode.toString(json, "accessToken"),
          idToken: Utils_Json$LiveRoom.Decode.toString(json, "idToken"),
          expiresIn: Utils_Json$LiveRoom.Decode.toInt(json, "expiresIn"),
          tokenType: Utils_Json$LiveRoom.Decode.toString(json, "tokenType")
        };
}

function parseErrors(errors) {
  var errorArrayDecoder = function (json) {
    return Belt_Option.map(Js_json.decodeArray(json), (function (x) {
                  return Belt_Array.map(x, (function (json) {
                                return {
                                        error: Utils_Json$LiveRoom.Decode.toString(json, "error"),
                                        error_description: Utils_Json$LiveRoom.Decode.toString(json, "error_description")
                                      };
                              }));
                }));
  };
  var singleErrorDecoder = function (json) {
    return {
            error: Belt_Option.getWithDefault(Utils_Json$LiveRoom.Decode.toOptionString(json, "error"), "unknown"),
            error_description: Belt_Option.getWithDefault(Utils_Json$LiveRoom.Decode.toOptionString(json, "error_description"), "Error while parsing error response from Auth0")
          };
  };
  try {
    var match = errorArrayDecoder(JSON.parse(errors));
    var match$1 = singleErrorDecoder(JSON.parse(errors));
    if (match !== undefined) {
      return Belt_Array.getExn(match, 0);
    } else {
      return match$1;
    }
  }
  catch (exn){
    return {
            error: "unknown",
            error_description: "Error while parsing error response from Auth0"
          };
  }
}

function make(config) {
  return new Auth0Js.WebAuth(auth0configToJs(config));
}

function checkSession(client, config) {
  return new Promise((function (resolve, param) {
                client.checkSession(checkSessionOptionsToJs(config), (function (err, res) {
                        if (err == null) {
                          return resolve({
                                      TAG: /* Ok */0,
                                      _0: parseResponse(Belt_Option.getWithDefault(JSON.stringify(res), "{}"))
                                    });
                        } else {
                          return resolve({
                                      TAG: /* Error */1,
                                      _0: parseErrors(Belt_Option.getWithDefault(JSON.stringify(err), "{}"))
                                    });
                        }
                      }));
              }));
}

export {
  auth0configToJs ,
  auth0configFromJs ,
  loginUrlBuilderOptionsToJs ,
  loginUrlBuilderOptionsFromJs ,
  logoutUrlBuilderOptionsToJs ,
  logoutUrlBuilderOptionsFromJs ,
  checkSessionOptionsToJs ,
  checkSessionOptionsFromJs ,
  AuthZeroJs ,
  parseResponse ,
  parseErrors ,
  make ,
  checkSession ,
}
/* auth0-js Not a pure module */
